import { useIntl } from '@umijs/max';
import { updateLocale, initMenuLocales } from '@/utils/i18n-utils';

export const useI18n = () => {
  const intl = useIntl();

  /**
   * 简化 formatMessage 调用
   * @param id 国际化 ID
   * @param defaultMessage 默认文本（可选）
   * @param values 变量值（可选）
   */
  const t = (id: string, defaultMessage?: string, values?: Record<string, any>) => {
    return intl.formatMessage({ id, defaultMessage }, values);
  };

  return { t, intl, updateLocale, initMenuLocales };
};

